<template>
  <!--https://webomnizz.com/create-toggle-switch-button-with-vue-js/-->
  <label
    :for="id + '_button'"
    :class="{ actives: isActive }"
    class="toggle__button_g"
    style="height: 0.93rem; margin: auto auto 0.5rem!important; gap: 0.8rem"
  >
    <span v-if="isActive" class="toggle__label">{{ enableText }}</span>
    <span v-else class="toggle__label">{{ disabledText }}</span>
    <input
      type="checkbox"
      :disabled="disabled"
      :id="id + '_button'"
      v-model="checkedValue"
    />
    <span class="toggle__switch_g"></span>
  </label>
</template>

<script>
export default {
  name: "ToggleButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    labelEnableText: {
      type: String,
      default: "On"
    },
    labelDisableText: {
      type: String,
      default: "Off"
    },
    id: {
      type: String,
      default: "primary"
    },
    defaultState: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentState: this.defaultState
    };
  },
  watch: {
    defaultState: function defaultState() {
      this.currentState = Boolean(this.defaultState);
    }
  },
  computed: {
    isActive() {
      return this.currentState;
    },
    enableText() {
      return this.labelEnableText;
    },
    disabledText() {
      return this.labelDisableText;
    },
    checkedValue: {
      get() {
        return this.currentState;
      },
      set(newValue) {
        this.currentState = newValue;
        this.$emit("change", newValue);
      }
    }
  }
};
</script>

<style scoped>
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "" !important;
}
</style>
